import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class PortalDailyDeliveredLogTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().toDate(),
      endDate: moment().toDate(),
      isLoading: false,
      customers: [],
      selectedCustomers: [],
      dailyDeliveredCarReportData: [],
      getReportUrl: '/api/v1/portal/portal-admin/daily-delivered-car-report/',
      customersDropdownUrl: "/api/v1/portal/customers/all/for-dropdown-menu",
      filename:"SIXT report.csv",
    };
    this.escapeCsvField = this.escapeCsvField.bind(this);
    this.downloadableCsvData = this.downloadableCsvData.bind(this);
  }

  componentDidMount() {
    this.fetchCustomers();
  }

  fetchCustomers = async () => {
    try {
      const response = await fetch(this.state.customersDropdownUrl, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + (window.api_token || ''),
          "Accept": 'application/json'
        },
      });

      if (!response.ok) throw new Error("Failed to fetch customers");

      const customersData = await response.json();

      const options = (customersData || []).map(customer => ({
        label: `${customer?.company?.short_name || 'N/A'}-${customer?.name || 'Unnamed'}`,
        value: customer?.id ?? null
      })).filter(option => option.value !== null);
      
      this.setState({ customers: options });
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  handleStartDateChange = (date) => this.setState({ startDate: date });
  handleEndDateChange = (date) => this.setState({ endDate: date });
  handleCustomerSelection = (selectedCustomers) => this.setState({ selectedCustomers });

  handleDailyDeliveredCarReportGeneration = async () => {
    this.setState({ isLoading: true });
    const { startDate, endDate, selectedCustomers, getReportUrl } = this.state;

    const payload = {
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
      customer_ids: selectedCustomers
    };
    
    try {
      const response = await fetch(getReportUrl + moment(startDate).format("YYYY-MM-DD"), {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + (window.api_token || ''),
          "Accept": 'application/json',
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
      });
      
      if (!response.ok) throw new Error("Failed to fetch report");
      
      const reportData = await response.json();
      this.setState({ dailyDeliveredCarReportData: Array.isArray(reportData) ? reportData : [], isLoading: false });
    } catch (error) {
      console.error("Error generating report:", error);
      this.setState({ isLoading: false });
    }
  };
  
  downloadableCsvData = (filename, text) => {
    this.setState({ isDownloading: true });
    let filenamed = filename + " FROM " + moment(this.state.startDate).format("YYYY-MM-DD") + " TO " + moment(this.state.endDate).format("YYYY-MM-DD") + ".csv";
    const textdata = "Job Number,Job Ref,Date Accepted,Registration,Make/Model,Collection Location (branch name),Delivery Location (OEM compound),Collection Date,Delivery Date,Cost,EV Charge,EV Charge Time,Miles driven,Fuel Cost,Abortive Cost,Reason/Auth By\n" +
      text.split("\n").map(row =>
        row.split(",").map(field => `"${field.replace(/"/g, '""')}"`).join(",")
      ).join("\n");

    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(textdata));
    element.setAttribute('download', filenamed);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    this.setState({ isDownloading: false });
  };

  escapeCsvField = (value) => {
    if (value == null) return;
    const str = String(value).replace(/,/g, '');
    return `${str}`;
  };

  render() {
    let dailyDeliveredCarReportData = [];
    let downloadCsvData = [];
    if (this.state.dailyDeliveredCarReportData.length > 0) {
      let totals = {
        formatted_job_price: 0,
        formatted_ev_charge_sum: 0,
        formatted_ev_charge_time_sum: 0,
        distance_in_miles: 0,
        formatted_fuel_toll_sum: 0,
        formatted_aborted_cost: 0,
      };

      this.state.dailyDeliveredCarReportData.map((job, index) => {
        // Accumulate totals for numeric fields
        totals.formatted_job_price += parseFloat(job?.formatted_job_price ?? '0');
        totals.formatted_ev_charge_sum += parseFloat(job?.formatted_ev_charge_sum ?? '0');
        totals.formatted_ev_charge_time_sum += parseFloat(job?.formatted_ev_charge_time_sum ?? '0');
        totals.distance_in_miles += parseFloat(job?.distance_in_miles ?? '0');
        totals.formatted_fuel_toll_sum += parseFloat(job?.formatted_fuel_toll_sum ?? '0');
        totals.formatted_aborted_cost += parseFloat(job?.formatted_aborted_cost ?? '0');

        dailyDeliveredCarReportData.push(
          <tr key={index}>
            <td><a href={`/jobs/view/${job?.id}`}>{job?.id ?? ''}</a></td>
            <td>{job?.customer_job_number ?? ''}</td>
            <td>{job?.created_at ?? ''}</td>
            <td>{job?.formatted_registration_number ?? ''}</td>
            <td>{job?.formatted_make_model ?? ''}</td>
            <td>{job?.formatted_pickup_address ?? ''}</td>
            <td>{job?.formatted_dropoff_address ?? ''}</td>
            <td>{job?.formatted_collection_date ?? ''}</td>
            <td>{job?.formatted_delivery_date ?? ''}</td>
            <td>&pound;{parseFloat(job?.formatted_job_price ?? '0').toFixed(2)}</td>
            <td>&pound;{parseFloat(job?.formatted_ev_charge_sum ?? '0').toFixed(2)}</td>
            <td>&pound;{parseFloat(job?.formatted_ev_charge_time_sum ?? '0').toFixed(2)}</td>
            <td>{job?.distance_in_miles ?? ''}</td>
            <td>&pound;{parseFloat(job?.formatted_fuel_toll_sum ?? '0').toFixed(2)}</td>
            <td>&pound;{parseFloat(job?.formatted_aborted_cost ?? '0').toFixed(2)}</td>
            <td>{job?.abortion_reason ?? ''}</td>
          </tr>
        );

        downloadCsvData +=
          this.escapeCsvField(job?.id) + ',' +
          this.escapeCsvField(job?.customer_job_number) + ',' +
          this.escapeCsvField(job?.created_at) + ',' +
          this.escapeCsvField(job?.formatted_registration_number) + ',' +
          this.escapeCsvField(job?.formatted_make_model) + ',' +
          this.escapeCsvField(job?.formatted_pickup_address) + ',' +
          this.escapeCsvField(job?.formatted_dropoff_address) + ',' +
          this.escapeCsvField(job?.formatted_collection_date) + ',' +
          this.escapeCsvField(job?.formatted_delivery_date) + ',' +
          this.escapeCsvField(parseFloat(job?.formatted_job_price ?? '0').toFixed(2)) + ',' +
          this.escapeCsvField(parseFloat(job?.formatted_ev_charge_sum ?? '0').toFixed(2)) + ',' +
          this.escapeCsvField(parseFloat(job?.formatted_ev_charge_time_sum ?? '0').toFixed(2)) + ',' +
          this.escapeCsvField(job?.distance_in_miles) + ',' +
          this.escapeCsvField(parseFloat(job?.formatted_fuel_toll_sum ?? '0').toFixed(2)) + ',' +
          this.escapeCsvField(parseFloat(job?.formatted_aborted_cost ?? '0').toFixed(2)) + ',' +
          this.escapeCsvField(job?.abortion_reason) + "\n";
      });

      // Add totals row to the table
      dailyDeliveredCarReportData.push(
        <tr key="totals">
          <td colSpan="9" className="text-right"><strong>Totals &nbsp;&nbsp;</strong></td>
          <td>&pound;{totals.formatted_job_price.toFixed(2)}</td>
          <td>&pound;{totals.formatted_ev_charge_sum.toFixed(2)}</td>
          <td>&pound;{totals.formatted_ev_charge_time_sum.toFixed(2)}</td>
          <td>{totals.distance_in_miles.toFixed(2)}</td>
          <td>&pound;{totals.formatted_fuel_toll_sum.toFixed(2)}</td>
          <td>&pound;{totals.formatted_aborted_cost.toFixed(2)}</td>
          <td></td>
        </tr>
      );

      // Add totals row to the CSV data
      downloadCsvData +=
        'Totals,' + ',,,,,,,' +
        totals.formatted_job_price.toFixed(2) + ',' +
        totals.formatted_ev_charge_sum.toFixed(2) + ',' +
        totals.formatted_ev_charge_time_sum.toFixed(2) + ',' +
        totals.distance_in_miles.toFixed(2) + ',' +
        totals.formatted_fuel_toll_sum.toFixed(2) + ',' +
        totals.formatted_aborted_cost.toFixed(2) + "\n";
    } else {
      dailyDeliveredCarReportData.push(
        <tr key="no-records"><td colSpan="15" className="text-center">No Records</td></tr>
      );
    }

    return (
      <div>
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <h2>SIXT Report</h2>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-1">
            <label><h5>Select Start Date:</h5></label><br />
            <DatePicker todayButton="Today" dateFormat="dd/MM/yyyy" selected={this.state.startDate} onChange={this.handleStartDateChange} />
          </div>
          <div className="col-md-1">
            <label><h5>Select End Date:</h5></label><br />
            <DatePicker todayButton="Today" dateFormat="dd/MM/yyyy" selected={this.state.endDate} onChange={this.handleEndDateChange} />
          </div>
          <div className="col-md-3 col-sm-12">
            <label><h3>Select Customer</h3></label><br />
            <StatefulMultiSelect
              options={this.state.customers}
              selected={this.state.selectedCustomers}
              onSelectedChanged={this.handleCustomerSelection}
              overrideStrings={{
                selectSomeItems: "Select Customers...",
                allItemsAreSelected: "All Customers are Selected",
                selectAll: "Select All",
                search: "Search",
              }}
            />
          </div>
          <div className="col-md-2 col-sm-12">
            <button className="btn btn-lg btn-success daily-delivered-btn-margin" onClick={this.handleDailyDeliveredCarReportGeneration} disabled={this.state.isLoading}>
              <i className="fa fa-save"></i> {this.state.isLoading ? 'Generating...' : 'Generate Report'}
            </button>
          </div>
          <div className="col-md-2 col-sm-12">
            <button className="btn btn-primary btn-lg daily-delivered-btn-margin"
              onClick={() => this.downloadableCsvData(this.state.filename, downloadCsvData)}
              disabled={dailyDeliveredCarReportData.length === 0}>
              <i className="fa fa-download"></i> Download for Spreadsheet
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <h4 className="alert alert-info text-center mt-4">
              {this.state.dailyDeliveredCarReportData.length} report data found..
            </h4>
            <div className="daily-delivered-report-tbl-scroll mt-3">
              <table className="daily-delivered-report-tbl">
                <thead className="sticky-top-without-zindex bg-light">
                  <tr>
                    <th>Job Number</th>
                    <th>Job Ref</th>
                    <th>Date Accepted</th>
                    <th>Registration</th>
                    <th>Make/Model</th>
                    <th>Collection Location (branch name)</th>
                    <th>Delivery Location (OEM compound)</th>
                    <th>Collection Date</th>
                    <th>Delivery Date</th>
                    <th>Cost</th>
                    <th>EV Charge</th>
                    <th>EV Charge Time</th>
                    <th>Miles driven</th>
                    <th>Fuel Cost</th>
                    <th>Abortive Cost</th>
                    <th>Reason/Auth By</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.isLoading ? (
                    <tr><td colSpan="15"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>
                  ) : (
                    dailyDeliveredCarReportData
                  )}
                </tbody>
              </table>
            </div>
            <br /><br /><br />
          </div>
        </div>
      </div>
    );
  }
}
